var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"f-r f-ac"},[_c('navbar-logo'),_c('h3',{staticStyle:{"margin":"0 20px"}},[_vm._v("Admin")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }